import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import _ from 'lodash';

import StateSelectorShapes from "./StateSelectorShapes";
import StateCountyHovers from "../Map/StateCountyHovers";
import StateOutline from "../Map/StateOutline";
import StateCountyBorders from "../Map/StateCountyBorders";
import HoverOver from "../HoverOver";

import '../Map/Map.css';
import './StateSelector.css';

class StateSelector extends Component {

  constructor(props) {
    super(props);

    this.state = {
      width: 500,
      height: 250
    };
  }

  componentDidMount() {
    this.handelResize(this.refs.wrapper.offsetWidth)
  }

  handelResize(width = 500) {
    const maxHeight = this.props.maxHeight || width;
    this.setState({width: width, height: Math.min(maxHeight, width * .61)});
  }

  render() {
    return (
      <div ref="wrapper" className="StateSelector" height={this.state.height}>
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <svg width={this.state.width} height={this.state.height}>
          <StateOutline
            stateFips={this.props.stateFips}
            width={this.state.width}
            height={this.state.height}/>
          <StateSelectorShapes
            width={this.state.width}
            height={this.state.height}
            stateFips={this.props.stateFips}
            selected={this.props.selectedCounty}/>
          <StateCountyBorders
            stateFips={this.props.stateFips}
            width={this.state.width}
            height={this.state.height}/>
          <StateCountyHovers
            width={this.state.width}
            height={this.state.height}
            stateFips={this.props.stateFips}
            onHoverOver={(countyFips, coords) => {
              const hover = {
                data: _.get(this, ['props', 'dict', countyFips], null),
                props: this.props,
                coords,
              };
              this.setState({hover});
            }}
            onHoverOut={() => {
              this.setState({hover: null})
            }}
            onClick={(stateFips, countyFips) => {
              if (this.props.onClick) {
                this.props.onClick(countyFips)
              }
            }}/>
        </svg>
        <HoverOver data={this.state.hover}/>
      </div>
    );
  }
}

StateSelector.propTypes = {
  onClick: PropTypes.func,
  maxHeight: PropTypes.number,
  stateFips: PropTypes.number,
  selectedCounty: PropTypes.number,
  dict: PropTypes.object
};

export default StateSelector;


// WEBPACK FOOTER //
// ./src/charts/StateSelector/index.js